import classNames from "classnames";
import clamp from "lodash/clamp";
import React, { FunctionComponent } from "react";
import "./style.scss";

interface Props {
  animated?: boolean;
  percent: number;
}

const ProgressBar: FunctionComponent<Props> = ({ animated = true, percent }) => {
  const clampedPercent = clamp(percent, 0, 100);

  return (
    <div
      className={classNames("ProgressBar", {
        "ProgressBar--animated": animated,
      })}
    >
      <div className="ProgressBar-bar" style={{ width: `${clampedPercent}%` }} />
    </div>
  );
};

export default ProgressBar;
